import { isMamba, isYonja, isLoveMailru } from 'common/constants'

export const isPushNotificationsEnabledForPartner = (partnerId: number) => {
  return isMamba(partnerId) || isYonja(partnerId) || isLoveMailru(partnerId)
}
